import { put, select } from "redux-saga/effects";
import importer from "common/importer";
const CentersActions = importer("Stores/Centers/Actions");
const { getFavoriteCenterInfo, getCoordinatesForZipcode } = importer(
  "APIs/centers",
  null
);
const { tokens } = importer("Stores/Users/Select", null);
const { donor } = importer("Stores/Donors/Select", null);
import { getDistance } from "geolib";
export default function* main({ donorSfid }) {
  try {
    const _tokens = yield select(tokens);
    const { token_type, id_token } = _tokens;
    const token = `${token_type} ${id_token}`;
    const _donor = yield select(donor);
    yield put(CentersActions.getFavoriteCenterInfoLoading());
    const res = yield getFavoriteCenterInfo(donorSfid, token);
    const geocodeRes = yield getCoordinatesForZipcode(_donor?.data?.zipCode);

    if (geocodeRes.data?.results.length === 0) {
      yield put(CentersActions.getFavoriteCenterInfoSuccess(res));
      return;
    }
    const givenLocation = {
      latitude: geocodeRes.data?.results[0]?.geometry.location.lat,
      longitude: geocodeRes.data?.results[0]?.geometry.location.lng,
    };
    const favouriteCenters = res.data?.favouriteCenters;
    const updatedFavouriteCenters = favouriteCenters.map((item) => {
      return {
        ...item,
        distanceFromGivenZipcode: (
          getDistance(givenLocation, {
            latitude: item.latitude,
            longitude: item.longitude,
          }) / 1609.34
        ).toFixed(2),
      };
    });
    res.data = {
      ...res.data,
      favouriteCenters: updatedFavouriteCenters,
    };
    yield put(CentersActions.getFavoriteCenterInfoSuccess(res));
  } catch (error) {
    yield put(CentersActions.getFavoriteCenterInfoFailure(error));
  }
}
